<script lang="ts" setup>
import {
  PaginationRoot as Pagination,
  PaginationList,
  PaginationListItem,
} from 'radix-vue'
import {useMediaQuery} from "@vueuse/core";

    const props = defineProps({
        total: {
            type: Number,
            required: true,
        },
        per_page: {
            type: Number,
            default: 15,
        },
        show_first_last: {
            type: Boolean,
            default: true,
        },
        btn_class: {
            type: String,
            default: 'w-8 h-8'
        },
        nav_btn_class: {
            type: String,
            default: 'w-8 h-8'
        }
    })

    const current_page = defineModel<number>('page')
    const isDesktop = useMediaQuery('(min-width: 768px)')
</script>

<template>
    <Pagination v-model:page="current_page" v-slot="{ page }" :total="total" :sibling-count="1" :show-edges="isDesktop" :default-page="1" :itemsPerPage="per_page" >
          <PaginationList v-slot="{ items }" class="flex items-center gap-1">
              <UiPaginationFirst v-if="show_first_last" :class="nav_btn_class"  />
              <UiPaginationPrev :class="nav_btn_class" />
  
              <template v-for="(item, index) in items">
                  <PaginationListItem v-if="item.type === 'page'" :key="index" :value="item.value" as-child>
                    <UiButton :class="btn_class" :disabled="item.value === page" :variant="item.value === page ? 'lighter' : 'outline'">
                        {{ item.value }}
                    </UiButton>
                  </PaginationListItem>
                  <UiPaginationEllipsis v-else :key="item.type" :index="index" />
              </template>
  
              <UiPaginationNext :class="nav_btn_class" />
              <UiPaginationLast v-if="show_first_last" :class="nav_btn_class" />
          </PaginationList>
      </Pagination>
  </template>

<style>

</style>